import { useEffect, useRef, useMemo } from 'react';
import _ from 'lodash';

const useDebouncedNew = (getData: any, delay: number) => {
  const getDataRef = useRef(getData);

  useEffect(() => {
    getDataRef.current = getData;
  }, [getData]);

  const debounced = useMemo(() => {
    const func = (...args: any[]) => {
      return getDataRef.current(...args);
    };
    return _.debounce(func, delay);
  }, [delay]);

  useEffect(() => {
    return () => {
      debounced.cancel();
    };
  }, [debounced]);

  return debounced;
};

export default useDebouncedNew;
